"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var logo_white_svg_1 = __importDefault(require("res/img/logo-white.svg"));
var SplashScreen = function (_a) {
    var exiting = _a.exiting;
    return (react_1.default.createElement("div", { className: "splash-screen " + (exiting ? "exiting" : "") },
        react_1.default.createElement("div", { className: "splash-screen__logo" },
            react_1.default.createElement("img", { src: logo_white_svg_1.default, alt: "RWD Logo" }))));
};
exports.default = SplashScreen;
